var _rect, _mask, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElevatorSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F0F0F0",
    rx: 11
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "wjpnh9w1pa",
    width: 11,
    height: 20,
    x: 10,
    y: 11,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 11h10.627v19.857H10V11z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#wjpnh9w1pa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M18.732 24.475l-2.325 2.503V12.093c0-.604-.489-1.094-1.094-1.094-.603 0-1.094.49-1.094 1.094v14.885l-2.325-2.503c-.41-.444-1.104-.469-1.545-.057-.442.411-.469 1.102-.056 1.546l4.22 4.544c.205.222.496.35.8.35.304 0 .595-.128.801-.35l4.22-4.544c.412-.444.386-1.135-.056-1.546-.44-.41-1.134-.385-1.546.057z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M29.707 15.893l-4.22-4.544c-.411-.445-1.19-.445-1.601 0l-4.22 4.544c-.412.443-.386 1.135.057 1.545.442.413 1.134.388 1.545-.056l2.325-2.504v14.885c0 .604.49 1.094 1.093 1.094.605 0 1.094-.49 1.094-1.094V14.878l2.325 2.504c.215.232.508.35.8.35.269 0 .535-.098.745-.294.443-.41.469-1.102.057-1.545z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevatorSmall);
export default __webpack_public_path__ + "static/media/elevator_small.5e76db4dd88527f6bdf97b4a1f1f148c.svg";
export { ForwardRef as ReactComponent };